/**
 * 受入ステータス件数
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/receives/summaries`

const order_receive_summary = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     *
     * @return {Promise<unknown>}
     */
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default order_receive_summary

